import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerMyChartersModule } from './customer-my-charters/customer-my-charters.module';
import { CustomerBasicInfoModule } from './customer-basic-info/customer-basic-info.module';
import { CustomerCharterDetailsModule } from './customer-charter-details/customer-charter-details.module';
import { CustomerPaymentInformationModule } from './customer-payment-information/customer-payment-information.module';
import { CharterAgreementSigningModule } from './agreement/charter-agreement-signing/charter-agreement-signing.module';
import { CustomerPhoneNumberEditModule } from './customer-phone-number-edit/customer-phone-number-edit.module';
import { CustomerBoatAvailableDifferentTimeModule } from './customer-boat-available-different-time/customer-boat-available-different-time.component.module';
import { CustomerOfferDetailsModule } from './charter-details/charter-details.module';
import { CustomerReviewModule } from './customer-review/customer-review.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CustomerMyChartersModule,
    CustomerOfferDetailsModule,
    CustomerBasicInfoModule,
    CustomerCharterDetailsModule,
    CustomerPaymentInformationModule,
    CharterAgreementSigningModule,
    CustomerPhoneNumberEditModule,
    CustomerBoatAvailableDifferentTimeModule,
    CustomerReviewModule,
  ],
})
export class CustomerModule {}
